import { useState, useEffect } from "react";
import axios from "../config/axios";


const useGet: UseFetch = (url: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const fetchedData = await axios.get(url);
        setData(fetchedData.data.data);
      } catch (err) {
        setError(true);
      } finally {
        setLoading(false);
      }
    })()
  }, [url])
  return [loading, error, data];
}

export default useGet;